import { render, staticRenderFns } from "./GenerateTestPaperDataTable.vue?vue&type=template&id=5499e8fe&scoped=true&"
import script from "./GenerateTestPaperDataTable.vue?vue&type=script&lang=js&"
export * from "./GenerateTestPaperDataTable.vue?vue&type=script&lang=js&"
import style0 from "./GenerateTestPaperDataTable.vue?vue&type=style&index=0&id=5499e8fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5499e8fe",
  null
  
)

export default component.exports